import { Share, ShareOptions } from "@capacitor/share";
import React from "react";

export default function useShare() {
  const [canShare, setCanShare] = React.useState(false);

  React.useEffect(() => {
    Share.canShare().then(({ value }) => setCanShare(value));
  }, []);

  const share = (options: ShareOptions) => {
    if (canShare) {
      Share.share(options);
    }
  };

  return { share, canShare };
}
